/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Stringcontainsnoneaspect14Inputs */

const de__class_stringcontainsnoneaspect14 = /** @type {(inputs: _Class_Stringcontainsnoneaspect14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`beinhaltet keines von`)
};

/**

* @param {_Class_Stringcontainsnoneaspect14Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_stringcontainsnoneaspect14 = /** @type {((inputs?: _Class_Stringcontainsnoneaspect14Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Stringcontainsnoneaspect14Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_stringcontainsnoneaspect14(inputs)
});
export { _class_stringcontainsnoneaspect14 as "_class_StringCONTAINSNONEAspect" }